import ListingFiltersModel from '../../../filters/ListingFiltersModel'
import { isEqual } from 'lodash-es'

export default class VariationListingFiltersModel extends ListingFiltersModel {
  isTextRangeGroup (group, entity = 'variations', displayType = group.variationDisplayType) {
    return super.isTextRangeGroup(group, entity, displayType)
  }

  inactivateBaseFilter (entry, activeFilters, field = 'variationId') {
    return super.inactivateBaseFilter(entry, activeFilters, field)
  }

  createLinkQueryStringForBaseGroup (group, entry, isFilterUsed) {
    let finalString = ''
    let duplicateEntryIds = []
    const activeFilters = [...this.activeFilters]

    const entryId = entry.variationId
    const duplicateEntryNames = this.duplicateNamesPerGroup[group.variationGroupId]
    const duplicateEntryNamesForEntry = duplicateEntryNames?.find(e => {
      return e.ids.includes(entryId)
    })

    if (duplicateEntryNamesForEntry) {
      duplicateEntryIds = duplicateEntryNamesForEntry.ids
      return this.createLinkQueryStringForDuplicateEntry(group, entry, isFilterUsed, activeFilters, duplicateEntryIds)
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)
      if (this.activeFilters.length === 1) {
        return this.queryStringForLastActiveFilter()
      }
    } else {
      finalString = this.addQueryString(group, entry, activeFilters) + '&' + this.filterQueryStringVar + '[]=' + entry.variationId

      if (this.activeFilters === null) {
        finalString = this.addQueryString(group, entry, activeFilters) + '?' + this.filterQueryStringVar + '[]=' + entry.variationId
      }
    }

    if (this.isTopLevelCategory) {
      return finalString + '/1'
    }

    return '/' + this.urlLang + this.uriWithoutOffset + finalString
  }

  createLinkQueryStringForRangeGroup (group, entry, isFilterUsed) {
    let finalString = ''
    const activeFilters = [...this.activeFilters]

    let stringWithAllIdsIncluded = ''
    for (const variationId of entry.chunkValueIds) {
      stringWithAllIdsIncluded += '&' + this.filterQueryStringVar + '[]=' + variationId
    }

    if (isFilterUsed) {
      finalString = this.removeQueryString(group, entry, activeFilters)

      if (!isEqual(activeFilters.sort(), entry.chunkValueIds.sort())) {
        return finalString
      }

      if (this.isTopLevelCategory) {
        return finalString + '/1'
      }

      return '/' + this.urlLang + this.uriWithoutOffset
    } else {
      if (this.activeFilters === null) {
        return this.addQueryString(group, entry, activeFilters) + '?' + stringWithAllIdsIncluded
      }
      return this.addQueryString(group, entry, activeFilters) + stringWithAllIdsIncluded
    }
  }

  createLinkQueryStringFinal (group, entry, isFilterUsed) {
    if (this.isTextRangeGroup(group)) {
      return this.createLinkQueryStringForRangeGroup(group, entry, isFilterUsed)
    } else {
      return this.createLinkQueryStringForBaseGroup(group, entry, isFilterUsed)
    }
  }
}
